// extracted by mini-css-extract-plugin
export default {"header":"view_header__2N84i","header__search":"view_header__search__lQgNZ"};